// extracted by mini-css-extract-plugin
export default {"splashContainer":"styles_splashContainer__xxb3n","logo":"styles_logo__cTX2O"};